import React from 'react'
import HintPopover from "../../../gd-ui/hint-popover/hint-popover"
import {ControlButtonSize} from "./@types";

export enum ControlButtonType {
    SEARCH          = 'search',

    SETTINGS        = 'settings',
    PREFERENCES     = 'preferences',

    REMOVE          = 'remove',
    DELETE          = 'delete',
    DELETE_GRAY     = 'delete-gray',
    PREVIEW         = 'preview',
    OPEN_IN_BROWSER = 'open-in-browser',
    DOWNLOAD        = 'download',
    ATTACHMENT      = 'attachment',
    ADD_SUBITEM     = 'add-subitem',
    ATTACHMENT_ADD  = 'attachment-add',
    EDIT            = 'edit',
    ADD_PAGE        = 'add-page',
    MORE            = 'more',
    COPY            = 'copy',

    PIN             = 'pin',
    UNPIN           = 'unpin',

    STAR            = 'star',
    UNSTAR          = 'unstar',

    PLUS            = 'plus',
    INFO            = 'info',
    ADD             = 'add',
    CROSS           = 'cross',
    CLOSE           = 'close',
    TOP_PANEL_UP    = 'top-panel-up',
    TOP_PANEL_DOWN  = 'top-panel-down',

    COLLAPSE_RIGHT  = 'collapse-right',

    COLLAPSE        = 'collapse',
    EXPAND          = 'expand',

    COLLAPSE_ALL    = 'collapse-all',
    EXPAND_ALL      = 'expand-all',

    ADD_TIME_REPORT = 'add-time-report',
    OK              = 'ok',
    HIDE_ITEMS      = 'hide-items',
    SHOW_ITEMS      = 'show-items',
    SORT            = 'sort',
    LINK            = 'link',
    TRAY            = 'tray',
    SIDE_PANEL      = 'side-panel',
    BACK            = 'back',

    COLLAPSE_CONTENT        = 'collapse-content',
    EXPAND_CONTENT          = 'expand-content',

    TIMER_STOP      = 'timer-stop',
    TIMER_PLAY      = 'timer-play',
    TIMER_PAUSE     = 'timer-pause',
    TIMER_CLOSE     = 'timer-close',    // delete timer
}

type Props = {
    id?             : string
    size?           : ControlButtonSize, // 20 | 24 | 28
    hint?           : string
    type?           : ControlButtonType         // yes it is optional becuase someone made it optional in editor ... fck
    iconClass?      : string

    className?      : string
    style?          : any
    children?       : any

    selectedClass?  : string

    isSelected?     : boolean
    isDisabled?     : boolean

    onMouseEnter?   : callback
    onMouseLeave?   : callback
    onClick?        : {(e:any):void}
}

export default class ControlButtonStandard extends React.Component<Props> {

    private types: any

    constructor(props:Props) {
        super(props)

        this.types = {
            [ControlButtonType.TOP_PANEL_UP]    : {
                iconClass   : "fs-14 i5-collapse-top"
            },
            [ControlButtonType.TOP_PANEL_DOWN]    : {
                iconClass   : "fs-14 i5-expand-top"
            },

            [ControlButtonType.SETTINGS]    : {
                iconClass   : "fs-15 i5-settings"
            },
            [ControlButtonType.PREFERENCES]    : {
                iconClass   : "fs-14 i5-preference-vertical"
            },

            [ControlButtonType.PIN]    : {
                iconClass   : "i5-pin"
            },
            [ControlButtonType.UNPIN]    : {
                iconClass   : "i5-pin-full"
            },
            [ControlButtonType.ADD_SUBITEM] : {
                iconClass   : "fs-14 i5-add-subtask"
            },
            edit    : {
                iconClass   : "fs-14 i5-pen"
            },
            remove: {
                iconClass   : "fs-16 i5-delete-circle-solid red"
            },
            [ControlButtonType.DELETE]: {
                iconClass   : "fs-14 i5-trash-alt ui5-color-red"
            },
            [ControlButtonType.DELETE_GRAY]: {
                iconClass   : "fs-14 i5-trash-alt"
            },
            preview: {
                iconClass   : "fs-14 i5-eye"
            },
            'open-in-browser': {
                iconClass   : "fs-14 i5-open-new-window"
            },
            'download': {
                iconClass   : "fs-14 i5-download"
            },
            'attachment': {
                iconClass   : "fs-14 i5-attachment"
            },
            [ControlButtonType.ATTACHMENT_ADD]    : { iconClass   : "fs-15 i5-attachment" },
            [ControlButtonType.ADD_PAGE]: {
                iconClass   : 'fs-14 i5-add-page'
            },
            [ControlButtonType.MORE]  : {
                iconClass   : 'fs-20 i5-more',  // 24
                iconClass28 : 'fs-20 i5-more'
            },
            [ControlButtonType.INFO]  : {
                iconClass   : 'fs-14 ii5-information'
            },
            'copy'  : {
                iconClass   : 'fs-14 i5-copy'
            },
            [ControlButtonType.PLUS]    : {
                iconClass   : "fs-12 i5-plus"
            },
            add    : {
                iconClass   : "fs-14 ui5-ico-add action"
            },
            cross    : {
                iconClass   : "fs-14 ui5-icon-close ui5-color-system-black action"
            },
            [ControlButtonType.CLOSE]    : {
                iconClass   : "fs-14 ui5-icon-close ui5-color-system-black action"
            },
            [ControlButtonType.ADD_TIME_REPORT]    : {
                iconClass   : "fs-12 i5-plus"
            },
            [ControlButtonType.OK] : {
                iconClass   : 'fs-14 ui5-ico-ok'
            },
            [ControlButtonType.HIDE_ITEMS] : {
                iconClass   : 'fs-14 i5-hide-items'
            },
            [ControlButtonType.SHOW_ITEMS] : {
                iconClass   : 'fs-14 i5-show-items'
            },
            [ControlButtonType.SORT]    : {
                iconClass   : "fs-14 i5-sort"
            },
            [ControlButtonType.LINK] : {
                iconClass   : 'fs-14 i5-copy-link'
            },
            [ControlButtonType.TRAY] : {
                iconClass   : 'fs-14 i5-minimize'
            },
            [ControlButtonType.TRAY] : {
                iconClass   : 'fs-14 i5-minimize'
            },
            [ControlButtonType.SIDE_PANEL] : {
                iconClass   : 'fs-14 i5-panel'
            },
            [ControlButtonType.BACK] : {
                iconClass   : 'fs-14 i5-long-arrow-left'
            },
            [ControlButtonType.TIMER_STOP] : {
                iconClass   : 'fs-13 red i5-stop-solid'
            },
            [ControlButtonType.TIMER_PLAY] : {
                iconClass   : 'fs-13 i5-play-solid'
            },
            [ControlButtonType.TIMER_PAUSE] : {
                iconClass   : 'fs-13 i5-pause-solid'
            },
            [ControlButtonType.TIMER_CLOSE] : {
                iconClass   : 'fs-13 i5-trash-alt'
            },

            [ControlButtonType.SEARCH] : {
                iconClass   : 'fs-14 i5-search'
            },

            [ControlButtonType.STAR] : {
                iconClass   : 'fs-14 i5-star-empty'
            },
            [ControlButtonType.UNSTAR] : {
                iconClass   : 'fs-14 i5-star ui5-color-yellow'
            },

            [ControlButtonType.COLLAPSE_RIGHT] : {
                iconClass   : ' fs-9 i5-big-angle-right'
            },

            [ControlButtonType.COLLAPSE] : {
                iconClass   : ' fs-9 i5-big-angle-up'
            },
            [ControlButtonType.EXPAND] : {
                iconClass   : 'i5-big-angle-down fs-9'
            },

            [ControlButtonType.COLLAPSE_CONTENT] : {
                // iconClass   : 'fs-14 i5-long-arrow-up'
                iconClass   : ' fs-10 i5-big-angle-up'
            },
            [ControlButtonType.EXPAND_CONTENT] : {
                // iconClass   : 'fs-14 i5-long-arrow-down'
                iconClass   : 'i5-big-angle-down fs-10'
            },

            [ControlButtonType.COLLAPSE_ALL] : {
                iconClass   : 'i5-collapse fs-12'
            },
            [ControlButtonType.EXPAND_ALL] : {
                iconClass   : 'i5-expand fs-12'
            },

        }
    }

    render() {

        const size = this.props.size || ControlButtonSize.SIZE_28
        const selectedClass = this.props.selectedClass || 'selected'

        const sizeClass     = "s-"+size

        let iconClass     = Classes(this.props.iconClass)

        if (this.props.type) {
            if (size === ControlButtonSize.SIZE_28 && this.types[this.props.type].iconClass28) {
                iconClass = Classes(this.types[this.props.type].iconClass28, iconClass)
            } else {
                iconClass = Classes(this.types[this.props.type].iconClass, iconClass)
            }

        }

        const buttonClass = Classes("ui5-control-button", iconClass, sizeClass, this.props.className, {
                [selectedClass] : this.props.isSelected,
                'disabled'      : this.props.isDisabled
            }
        )

        return (
            <div id             = {this.props.id}
                 className      = {buttonClass}
                 style          = {this.props.style}
                 onMouseEnter   = {this.props.isDisabled ? undefined : this.props.onMouseEnter}
                 onMouseLeave   = {this.props.isDisabled ? undefined : this.props.onMouseLeave}
                 onClick        = {this.props.isDisabled ? undefined : this.props.onClick}>

                {this.props.hint &&
                    <HintPopover hint={this.props.hint}/>
                }

                {this.props.children}
            </div>
        )
    }
}
